<template>
    <div class='noData'> 
        <van-empty :description="content"  />
    </div>
</template>

<script>
export default {
    props:{
       content:{
          typeOf:String,
          default:'暂无数据'
       }
    },
    mounted(){
      this.$store.commit("setPageLoading", false);
    }
};
</script>

<style scoped lang="less">
.noData{
    overflow: hidden;
    p{
        text-align: center;
        margin-top: 100px;
        color: #888;
        // font-style: oblique;
    }
}
</style>
